import { Image, Text } from '@belong/ui';
import clsx from 'clsx';

export const TrustpilotStars = ({
  theme = 'light',
}: {
  theme?: 'light' | 'dark';
}) => {
  return (
    <div className="flex items-center">
      <div className="mr-xs relative" style={{ width: '127px' }}>
        <Image src="/icons/trustpilot-stars.svg" alt="4.5 Stars" />
        <div
          className="absolute inset-y-0 right-0 opacity-60"
          style={{ width: '8px' }}
        />
      </div>
      <Text
        variant="h3"
        fontWeight="semibold"
        className={clsx({
          'text-navy': theme === 'light',
          'text-white': theme === 'dark',
        })}
      >
        on
      </Text>
      <div className="ml-xs" style={{ width: '120px', marginTop: '3px' }}>
        <Image src="/logos/trustpilot-logo.svg" alt="Trustpilot" />
      </div>
    </div>
  );
};
